import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import useScript from "../../const/useScript";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Event from "../../components/home/Event";
import Partners from "../../components/home/Partners";
import Service from "../../components/home/Service";
import Contact from "../admin/contact";

const Transform = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.result === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useScript("https://www.googletagmanager.com/gtag/js?id=AW-18021721006");

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `gtag('event', 'conversion', {
      'send_to': 'AW-18021721006/V_ECCKHk5YocEK7HtpFD',
      'value': 1.0,
      'currency': 'KRW'
  });`;

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div>
      <Banner />
      <About />
      <Service />
      <Blog data={data} />
      <Event />
      <Contact />
      <Partners />
    </div>
  );
};

export default Transform;
